<ng-template #quote let-modal class="col-12">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{popupTitle}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
   <div *ngIf="isExpired" class="col-12 pb-3">
        <div class="row">
          <div class="col col-12 alert alert-danger">
            This quote has been expired
          </div>
        </div>
      </div>
      <div *ngIf="application.status ==  'PROG' " class="col-12 pb-3">
        <div class="row">
          <div class="col col-12 alert alert-info">
            If you require assistance, email <a [href]="'mailto:bcfpayments@bct.nsw.gov.au?subject=Request for Quote Application Change - ' + application.referenceNumber">bcfpayments@bct.nsw.gov.au</a>
          </div>
        </div>
      </div>
      <div *ngIf="draftPayment != '' " class="col-12 pb-3">
        <div class="row">
          <div class="col col-12 alert alert-danger">
            Please complete your draft BCF payment request {{draftPayment}}. If you require assistance, email <a [href]="'mailto:bcfpayments@bct.nsw.gov.au'">bcfpayments@bct.nsw.gov.au</a>
          </div>
        </div>
      </div>

    <div class="col">
      <div class="col-12">
      <!-- <div class="row">
        <div class="col-10 form-group">
          <label class="control-label col-3 text-left d-inline-block"><strong>Quote No.</strong></label><span class="ml-1">{{application.referenceNumber}}</span>
        </div>
      </div> -->
      <div class="row">
        <div class="col-10 form-group form-inline">
          <label class="control-label col-3 text-left d-inline-block">Proponent name</label><span class="ml-1">{{application.applicant.firstName}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-10 form-group form-inline">
          <label class="control-label col-3 text-left d-inline-block">Development name</label><span class="ml-1">{{application.developmentName}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-10 form-group form-inline">
          <label class="control-label col-3 text-left d-inline-block">Process status</label><span class="ml-1">{{status}}</span>
          <span class="p-2"><tooltip register="External" tab="Quote" section="Quote details" field="Process status"></tooltip></span>
        </div>
      </div>
      <div class="row">
        <div class="col-10 form-group">
          <label class="control-label col-3 text-left d-inline-block align-top"><strong>Documents</strong></label>
          <div class="ml-1 d-inline-block">
            <a href="javascript:void(0)" (click)="downloadRFQ();">RFQ Application</a>
            <span class="p-2"><tooltip register="External" tab="Quote" section="Quote details" field="RFQ"></tooltip></span>
            <br/>
           <div class="mt-1" *ngIf="showViewQuote"><a href="javascript:void(0)" (click)="downloadQuote();">Quote</a>
            <span class="p-2"><tooltip register="External" tab="Quote" section="Quote details" field="Quote"></tooltip></span>
          </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col col-10 form-group">
          <label class="col-3">&nbsp;</label>
          <button class="btn btn-primary ml-1 text-left d-inline-block" [disabled]="!allowSubmit" (click)="submitRTMP()">Request to make payment</button>
          <span class="p-2"><tooltip register="External" tab="Quote" section="Quote details" field="Button"></tooltip></span>
        </div>
      </div>
      <div class="row" *ngIf="!showViewQuote">
        <div class="col col-10 form-group">
          <label class="col-3">&nbsp;</label>
          <small class="ml-1  d-inline-block">
            A request to make payment application can only be submitted if a quote has been issued.
          </small>
        </div>
      </div>
      
        <h5>Details</h5>
        <div class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-3 text-left d-inline-block">Application category</label><span class="ml-1">{{category}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-3 text-left d-inline-block">Quote application date</label><span class="ml-1">{{application.submittedDate | date: 'dd/MM/yyyy'}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-3 text-left d-inline-block">Quote issue date</label><span class="ml-1">{{issueDate}}</span>
          </div>
        </div>
        <div class="row" *ngIf="showViewQuote">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-3 text-left d-inline-block">Quote expiry date</label><span class="ml-1">{{application.expiryDate | date: 'dd/MM/yyyy'}}</span>
          </div>
        </div>
      </div>
      <div class="col col-12">
        <h5>Quote statement</h5>
        <div class="row mb-3" *ngIf="!showViewQuote">
        <div class="col col-10 form-group">
          <small class="ml-1  d-inline-block">
            Payment details will be displayed here once the quote has been issued.
          </small>
        </div>
      </div>
        <!-- <ag-grid-angular style="width: 100%;height:350px"
                         class="ag-theme-alpine"
                         [rowData]="quoteCredits"
                         [columnDefs]="quoteCreditColumnDefs"
                         [pagination]="true"
                         [resizable]="true"
                         [defaultColDef]="defaultColDef"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular> -->
      <app-quote-credit-payment-grids
        [quoteCredits]="quoteCredits"
        [isRFQAfterAmendment]="isRFQAfterAmendment"
        [bcfPaymentFee]="bcfPaymentFee"
        [quoteStatus]="application?.status"
        [scope]="'public-quote'">
      </app-quote-credit-payment-grids>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">Close</button>
  </div>
</ng-template>

